import LeftSide from "/components/layouts/leftSide";
import Menu from "./menu";
import { useSelector } from "react-redux";
import Link from "next/link";
import styles from "./index.module.scss";
import { useMemo, useState } from "react";
import { useRouter } from "next/router";
import LayoutWrapper from "../../layouts/layoutWrapper";
import Videos from "../../common/videos";
import clsx from "clsx";

export default function Faq({
  code,
  scripts,
  host,
  videos = [],
  isBaltex,
  isLanding,
}) {
  const { questions, questionSections } = useSelector((state) => state.content);

  const router = useRouter();

  const sectionNames = useMemo(() => {
    const sectionNames = {};
    questionSections.forEach((section) => {
      sectionNames[section.ID] = section.NAME;
    });
    return sectionNames;
  }, [questionSections]);

  const [openedQuestions, toggleQuestions] = useState({});

  const filteredQuestions = useMemo(() => {
    if (code) {
      const section = questionSections.find((sect) => sect.CODE === code);
      return questions.filter(
        (question) => question.IBLOCK_SECTION_ID === section.ID,
      );
    }
    return questions;
  }, [questions]);

  return (
    <LayoutWrapper scripts={scripts} host={host}>
      <LeftSide
        isBaltex={isBaltex}
        side={<Menu isBaltex={isBaltex} />}
        title="Вопросы и ответы"
      >
        {!isBaltex && !isLanding && <Videos items={videos} />}
        <ul className={clsx(isBaltex && styles.MenuBaltex, styles.Menu)}>
          <li>
            <Link href="/faq">
              <a className={router.asPath === "/faq/" && styles.Selected}>
                Все категории
              </a>
            </Link>
          </li>
          {questionSections.map((section) => (
            <li key={section.ID}>
              <Link href={`/faq/${section.CODE}/`}>
                <a
                  className={
                    router.asPath === `/faq/${section.CODE}/` && styles.Selected
                  }
                >
                  {section.NAME}
                </a>
              </Link>
            </li>
          ))}
        </ul>

        <ul
          className={clsx(isBaltex && styles.QuestionBaltex, styles.Question)}
        >
          {filteredQuestions.map((question) => (
            <li
              key={question.ID}
              data-test="faqQuestion"
              onClick={() =>
                toggleQuestions({
                  ...openedQuestions,
                  [question.ID]: !openedQuestions[question.ID],
                })
              }
            >
              <div className={styles.SectionName}>
                {sectionNames?.[question.IBLOCK_SECTION_ID]}
              </div>
              <span className={styles.Name}>{question.NAME}</span>

              {openedQuestions[question.ID] && (
                <div
                  data-test="faqAnswer"
                  className={styles.Text}
                  dangerouslySetInnerHTML={{ __html: question.DETAIL_TEXT }}
                ></div>
              )}
            </li>
          ))}
        </ul>
      </LeftSide>
    </LayoutWrapper>
  );
}
